const HomeBannerImage = () => {
  return (
    <div>
      <meta charSet="UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Document</title>
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n      svg#freepik_stories-directions:not(.animated) .animable {\n        opacity: 0;\n      }\n      svg#freepik_stories-directions.animated\n        #freepik--background-complete--inject-42 {\n        animation: 1.9s 1 forwards cubic-bezier(0.36, -0.01, 0.5, 1.38)\n            slideLeft,\n          3s Infinite linear wind;\n        animation-delay: 0s, 1.9s;\n      }\n      svg#freepik_stories-directions.animated #freepik--Device--inject-42 {\n        animation: 1s 1 forwards cubic-bezier(0.36, -0.01, 0.5, 1.38) fadeIn;\n        animation-delay: 0s;\n      }\n      svg#freepik_stories-directions.animated\n        #freepik--speech-bubble--inject-42 {\n        animation: 1s 1 forwards cubic-bezier(0.36, -0.01, 0.5, 1.38) slideLeft,\n          1.5s Infinite linear floating;\n        animation-delay: 0s, 1s;\n      }\n      svg#freepik_stories-directions.animated #freepik--Character--inject-42 {\n        animation: 1s 1 forwards cubic-bezier(0.36, -0.01, 0.5, 1.38) slideDown;\n        animation-delay: 0s;\n      }\n      svg#freepik_stories-directions.animated #freepik--Floor--inject-42 {\n        animation: 1s 1 forwards cubic-bezier(0.36, -0.01, 0.5, 1.38) zoomOut;\n        animation-delay: 0s;\n      }\n      @keyframes slideLeft {\n        0% {\n          opacity: 0;\n          transform: translateX(-30px);\n        }\n        100% {\n          opacity: 1;\n          transform: translateX(0);\n        }\n      }\n      @keyframes wind {\n        0% {\n          transform: rotate(0deg);\n        }\n        25% {\n          transform: rotate(1deg);\n        }\n        75% {\n          transform: rotate(-1deg);\n        }\n      }\n      @keyframes fadeIn {\n        0% {\n          opacity: 0;\n        }\n        100% {\n          opacity: 1;\n        }\n      }\n      @keyframes floating {\n        0% {\n          opacity: 1;\n          transform: translateY(0px);\n        }\n        50% {\n          transform: translateY(-10px);\n        }\n        100% {\n          opacity: 1;\n          transform: translateY(0px);\n        }\n      }\n      @keyframes slideDown {\n        0% {\n          opacity: 0;\n          transform: translateY(-30px);\n        }\n        100% {\n          opacity: 1;\n          transform: translateY(0);\n        }\n      }\n      @keyframes zoomOut {\n        0% {\n          opacity: 0;\n          transform: scale(1.5);\n        }\n        100% {\n          opacity: 1;\n          transform: scale(1);\n        }\n      }\n    ',
        }}
      />
      <svg
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        className="animated"
        id="freepik_stories-directions"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="freepik--background-complete--inject-42"
          className="animable animator-active"
          style={{ transformOrigin: '252.361px 250.814px' }}
        >
          <path
            d="M451.74,57.82c.55-4-5.09-7.29-9.33-7.63-2-.16-4.13.14-6-.52-4.15-1.45-5.81-6.81-9.86-8.52-3-1.28-6.51-.14-9.45,1.34S411.23,45.82,408,46c-2.85.19-5.95-.87-8.45.52-1.86,1-2.83,3.18-4.54,4.45A10.9,10.9,0,0,1,389,52.61a16.65,16.65,0,0,0-6.13,1c-1.89.87-3.46,2.87-3.06,4.92Z"
            style={{ fill: 'rgb(234, 234, 234)', transformOrigin: '415.762px 49.5626px' }}
            id="elgxzs5n7t1rw"
            className="animable"
          />
          <path
            d="M161.31,62.48c.86-6.26-8-11.4-14.6-11.94-3.17-.25-6.45.23-9.45-.81-6.49-2.27-9.09-10.66-15.42-13.33-4.74-2-10.19-.22-14.78,2.09S97.93,43.71,92.79,44c-4.46.29-9.3-1.37-13.21.81-2.91,1.63-4.43,5-7.11,7s-6,2.34-9.3,2.52-6.63.21-9.59,1.57-5.42,4.49-4.8,7.69Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '105.026px 49.5613px' }}
            id="elurb2q8cojpa"
            className="animable"
          />
          <path
            d="M391,98c.84-6.11-7.78-11.14-14.26-11.66-3.09-.25-6.29.22-9.22-.8-6.34-2.21-8.88-10.4-15.06-13-4.63-2-9.95-.21-14.44,2s-8.92,5.1-13.93,5.42c-4.35.28-9.09-1.33-12.9.79-2.84,1.59-4.33,4.86-7,6.8s-5.9,2.29-9.08,2.46-6.47.2-9.37,1.53-5.29,4.39-4.69,7.51Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '336.007px 85.361px' }}
            id="el3689wwg9x4e"
            className="animable"
          />
          <path
            d="M379.59,465.39c-21.11-9.74-29.73-33.3-32.91-55.3-.54-3.68-1.63-7.45-.47-11s4.82-6.43,8.37-5.48c2.94.79,4.69,3.74,6.67,6.07a21.66,21.66,0,0,0,10,6.64c2.54.79,5.55,1,7.62-.67,2.83-2.3,2.42-6.71,1.75-10.34q-1.89-10.14-3.77-20.28c-.68-3.62-1.35-7.33-.84-11s2.43-7.29,5.71-8.88,7.91-.36,9.28,3.06a35.15,35.15,0,0,1,.91,4.5c.37,1.49,1.37,3,2.88,3.19s2.79-1.12,3.69-2.38c3.09-4.34,4.78-9.51,6.32-14.64s3-10.34,5.66-14.95,6.81-8.62,12-9.85,11.26,1,13.49,5.86.18,10.61-2.32,15.33a82.36,82.36,0,0,1-14,19.12,6.73,6.73,0,0,0-2.28,3.54c-.35,2.56,2.37,4.55,4.91,4.92,2.86.41,5.75-.39,8.64-.57s6.18.52,7.73,3c2.16,3.44-.25,7.89-2.84,11a70.43,70.43,0,0,1-18.42,15.55c-2.5,1.46-5.15,2.82-7,5.08s-2.53,5.76-.77,8.08,5.25,2.55,7.95,1.53,4.94-3,7.42-4.47c4.65-2.78,11.16-3.6,15.13.14,2.61,2.46,3.5,6.37,3,9.94a26.71,26.71,0,0,1-3.89,10c-6.31,10.82-15.19,20.21-26,26.3s-21.38,9.1-33.64,7"
            style={{ fill: 'rgb(234, 234, 234)', transformOrigin: '394.464px 394.922px' }}
            id="el79g2rhjph29"
            className="animable"
          />
          <path
            d="M382.78,450.67a332.39,332.39,0,0,1,6.62-37.34q1.14-4.92,2.24-9.7c.75-3.18,1.48-6.34,2.39-9.38a166.57,166.57,0,0,1,6.24-17.18c2.25-5.37,4.57-10.38,6.78-15.05s4.38-9,6.51-12.82A130.89,130.89,0,0,1,425,331.81c1.5-1.94,2.72-3.4,3.55-4.39l1-1.11a2.36,2.36,0,0,1,.34-.36,3,3,0,0,1-.29.41l-.9,1.15c-.8,1-2,2.5-3.45,4.47A137.84,137.84,0,0,0,414,349.43c-2.1,3.85-4.22,8.17-6.42,12.84s-4.49,9.69-6.72,15.05a169.54,169.54,0,0,0-6.17,17.12c-.9,3-1.63,6.16-2.37,9.35s-1.48,6.42-2.23,9.69a337.68,337.68,0,0,0-6.67,37.26"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '406.335px 388.345px' }}
            id="el1j3ql15vrz2i"
            className="animable"
          />
          <path
            d="M394.22,394.19a7.79,7.79,0,0,1-.63-1.49c-.37-1-.86-2.38-1.44-4.15-1.17-3.52-2.6-8.44-4.17-13.87s-3.07-10.32-4.28-13.81c-.6-1.75-1.11-3.16-1.46-4.13a7.46,7.46,0,0,1-.49-1.54,7.36,7.36,0,0,1,.73,1.44c.43.94,1,2.33,1.67,4.06,1.33,3.47,2.91,8.35,4.48,13.79s2.92,10.21,4,13.92l1.24,4.21A7.32,7.32,0,0,1,394.22,394.19Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '387.985px 374.695px' }}
            id="eli79br61p7jo"
            className="animable"
          />
          <path
            d="M439.33,377.09a10.83,10.83,0,0,1-1.82.55c-1.18.33-2.89.78-5,1.41-4.19,1.23-9.92,3.13-16.15,5.51s-11.78,4.78-15.74,6.63c-2,.91-3.58,1.69-4.68,2.22a10.68,10.68,0,0,1-1.74.78,10.71,10.71,0,0,1,1.62-1c1.07-.61,2.63-1.46,4.59-2.43,3.92-2,9.46-4.44,15.7-6.84a166.1,166.1,0,0,1,16.27-5.32c2.12-.58,3.85-1,5.05-1.21A9.76,9.76,0,0,1,439.33,377.09Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '416.765px 385.64px' }}
            id="elwvkkqj2b9bf"
            className="animable"
          />
          <path
            d="M383.2,449.71a2.53,2.53,0,0,1-.42-.51l-1.11-1.55c-.95-1.35-2.27-3.33-3.88-5.8-3.21-5-7.43-11.91-12-19.66S357.1,407.43,354,402.43l-3.7-5.91c-.4-.65-.73-1.18-1-1.62a2.11,2.11,0,0,1-.31-.59,2.55,2.55,0,0,1,.42.51l1.1,1.55c1,1.34,2.27,3.33,3.88,5.8,3.21,4.94,7.43,11.91,12,19.67s8.7,14.74,11.81,19.75l3.69,5.91,1,1.62A2.33,2.33,0,0,1,383.2,449.71Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '366.095px 422.01px' }}
            id="ellg6p43ktyno"
            className="animable"
          />
          <path
            d="M441.64,418.58a2.67,2.67,0,0,1-.57.37l-1.7.92-6.25,3.35c-5.28,2.82-12.53,6.81-20.54,11.23s-15.3,8.34-20.64,11.05c-2.67,1.36-4.85,2.44-6.36,3.15l-1.75.82a2.43,2.43,0,0,1-.63.24,2.35,2.35,0,0,1,.57-.37l1.69-.92,6.26-3.35c5.28-2.82,12.53-6.81,20.54-11.23s15.29-8.34,20.63-11c2.68-1.36,4.85-2.44,6.36-3.15l1.75-.82A3,3,0,0,1,441.64,418.58Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '412.42px 434.145px' }}
            id="el1yozu004tmz"
            className="animable"
          />
          <polygon
            points="472.76 214.4 453.57 198.63 453.46 207.16 399.93 206.49 399.75 220.5 453.29 221.16 453.19 229.38 472.76 214.4"
            style={{ fill: 'rgb(234, 234, 234)', transformOrigin: '436.255px 214.005px' }}
            id="elef05mtn7d7"
            className="animable"
          />
          <polygon
            points="444.23 237.07 431.84 226.9 431.77 232.4 397.21 231.97 397.1 241.01 431.66 241.44 431.59 246.75 444.23 237.07"
            style={{ fill: 'rgb(234, 234, 234)', transformOrigin: '420.665px 236.825px' }}
            id="el4k72gw0m8w5"
            className="animable"
          />
          <path
            d="M37.11,110.05s-11.16,3.47-.62,27.43,18.1,36,18.1,36,1.79,5.52-2.8,6.1-14.52-1.59-16.87,3.85C32.49,189,36.37,194.72,44.59,200S70.42,217.45,72,218.56s3,3.69,0,4.59-25.73,1.95-24.58,12.67,26.47,21.63,29.21,22.87,3.35,2.48,3,4-8,1.16-14.4,1.72-13.8,2.35-12.62,8.48,15.77,19.71,52.77,25.5L122.71,300,133,285.84c20.17-31.55,19.67-51.48,15.85-56.42s-10-.61-14.7,3.84-9.48,10.41-10.84,9.64-1.87-2-1-4.92,9.5-29.08,2.22-37-23.07,8.32-25.78,10-3.68-1.12-3.46-3,2.74-23.19,4.24-32.84-.18-16.32-6-18.24c-5.63-1.85-10.58,7-14.06,10.08S73,165,73,165s-4-13.61-14.95-37.37-21.18-17.5-21.18-17.5"
            style={{ fill: 'rgb(234, 234, 234)', transformOrigin: '91.4452px 204.692px' }}
            id="elz6i98j1gb7"
            className="animable"
          />
          <path
            d="M123.37,304.09c-8-17.48-21.66-48.79-33.54-75.61s-22.65-51.07-30.55-68.59l-9.37-20.74-2.54-5.64c-.28-.64-.5-1.12-.65-1.48s-.21-.51-.21-.51.1.17.26.49.39.83.69,1.45c.62,1.3,1.5,3.18,2.64,5.6,2.29,4.86,5.54,11.93,9.53,20.67,8,17.48,18.82,41.72,30.69,68.53s25.5,58.15,33.4,75.67"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '85.115px 217.805px' }}
            id="elmwzistvotz"
            className="animable"
          />
          <path
            d="M48.68,187a6.35,6.35,0,0,1,1.19.41c.76.29,1.83.74,3.16,1.32,2.65,1.15,6.27,2.83,10.23,4.75l10.13,5,3.08,1.49a6,6,0,0,1,1.11.59,6,6,0,0,1-1.2-.4c-.75-.29-1.83-.75-3.15-1.33C70.59,197.6,67,195.88,63,194l-10.16-4.9-3.08-1.47A5.22,5.22,0,0,1,48.68,187Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '63.13px 193.78px' }}
            id="el36wl7z4shb2"
            className="animable"
          />
          <path
            d="M78.83,199.47c-.14-.06,3-7.68,7-17s7.36-16.87,7.5-16.81-3,7.68-7,17S79,199.53,78.83,199.47Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '86.08px 182.565px' }}
            id="el0abo17crpyfd"
            className="animable"
          />
          <path
            d="M95.21,241.47a5.26,5.26,0,0,1,.76-1l2.22-2.7c1.87-2.27,4.44-5.43,7.14-9s5.06-6.91,6.74-9.33l2-2.87a6.12,6.12,0,0,1,.78-1,6.46,6.46,0,0,1-.61,1.14c-.42.71-1,1.72-1.85,3-1.59,2.48-3.9,5.85-6.62,9.44s-5.33,6.72-7.28,8.94c-1,1.11-1.78,2-2.35,2.59A6.73,6.73,0,0,1,95.21,241.47Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '105.03px 228.52px' }}
            id="elhyo5jgzjgtu"
            className="animable"
          />
          <path
            d="M65.46,236.18a4.38,4.38,0,0,1,1.18.09l3.2.44c2.69.39,6.41,1,10.51,1.65s7.81,1.31,10.49,1.8l3.17.61a5.2,5.2,0,0,1,1.15.3A5.84,5.84,0,0,1,94,241l-3.19-.44c-2.7-.39-6.42-1-10.52-1.65s-7.81-1.32-10.49-1.81l-3.16-.61A5.18,5.18,0,0,1,65.46,236.18Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '80.31px 238.623px' }}
            id="eli4tmg43bi8"
            className="animable"
          />
          <path
            d="M75.21,275.09a8.86,8.86,0,0,1,1.51.13l4.1.55c3.46.49,8.23,1.19,13.49,2s10,1.58,13.47,2.16l4.07.72a7.33,7.33,0,0,1,1.48.34,8.86,8.86,0,0,1-1.51-.13l-4.1-.55c-3.46-.48-8.23-1.19-13.49-2s-10-1.58-13.47-2.16l-4.07-.72A7.33,7.33,0,0,1,75.21,275.09Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '94.27px 278.04px' }}
            id="el5r4zy66hbsf"
            className="animable"
          />
          <path
            d="M112.46,280.6a9.54,9.54,0,0,1,.94-1.33l2.69-3.52c2.26-3,5.38-7.09,8.69-11.73s6.21-8.91,8.28-12l2.45-3.69a11.71,11.71,0,0,1,1-1.32,10.06,10.06,0,0,1-.78,1.44c-.53.9-1.31,2.19-2.31,3.77-2,3.17-4.84,7.49-8.16,12.14s-6.49,8.73-8.83,11.65c-1.18,1.45-2.14,2.62-2.83,3.41A9.08,9.08,0,0,1,112.46,280.6Z"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '124.485px 263.805px' }}
            id="el34fop5zk3wn"
            className="animable"
          />
        </g>
        <g id="freepik--Plant--inject-42" className="animable" style={{ transformOrigin: '211.06px 382.95px' }}>
          <path
            d="M371.48,424a8.13,8.13,0,0,1,4.36,4.64,14.44,14.44,0,0,1,.77,6.46c-.35,4.21-2.6,8.53-5.07,12-3.63-3-4.61-8.33-4.94-11.08-.52-4.35,1.19-12.52,4.88-12"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '371.602px 435.548px' }}
            id="elvo0ed0j6doe"
            className="animable"
          />
          <path
            d="M375.87,453.82a6.92,6.92,0,0,1,2-6.67,9.21,9.21,0,0,1,6.73-2.34,3.88,3.88,0,0,1,3,1.25,3,3,0,0,1,.14,3,6.08,6.08,0,0,1-2.16,2.26c-3,2-6.28,3.42-9.78,2.49"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '381.877px 449.447px' }}
            id="elhzh6jjnimw8"
            className="animable"
          />
          <path
            d="M371.73,466.83a5.36,5.36,0,0,1,.1-.86c.09-.61.21-1.4.36-2.35a24.28,24.28,0,0,1,2.17-7.52,14.91,14.91,0,0,1,5.17-5.85,10.23,10.23,0,0,1,2.15-1,5.66,5.66,0,0,1,.63-.18c.14,0,.22-.05.22,0a16,16,0,0,0-2.88,1.43,15.29,15.29,0,0,0-5,5.81,26.25,26.25,0,0,0-2.24,7.42c-.18,1-.33,1.78-.45,2.33A4.25,4.25,0,0,1,371.73,466.83Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '377.13px 457.939px' }}
            id="elskw78bx653s"
            className="animable"
          />
          <path
            d="M370.73,430.28a1.65,1.65,0,0,1,0,.38c0,.28.06.64.1,1.08.08.94.18,2.3.29,4,.21,3.36.44,8,.58,13.15s.15,9.79.12,13.16c0,1.68,0,3.05-.07,4,0,.44,0,.8,0,1.08a1.88,1.88,0,0,1,0,.38s0-.13,0-.38,0-.64,0-1.08c0-1,0-2.34,0-4,0-3.37-.07-8-.21-13.15s-.33-9.79-.49-13.15c-.08-1.65-.14-3-.19-4,0-.45,0-.81,0-1.09A2.21,2.21,0,0,1,370.73,430.28Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '371.282px 448.895px' }}
            id="elucggjwv6yji"
            className="animable"
          />
          <path
            d="M369.83,456.56a16.25,16.25,0,0,0-9.24-11.62c-1.2-.53-2.75-.85-3.7.06s-.68,2.48-.16,3.69a13.87,13.87,0,0,0,13,8.22"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '363.044px 450.67px' }}
            id="el1rh97abjn1k"
            className="animable"
          />
          <path
            d="M361.29,448.91a4.51,4.51,0,0,1,.76.3,8.56,8.56,0,0,1,.86.43,12.64,12.64,0,0,1,1.1.64c.39.26.83.54,1.26.89s.89.73,1.36,1.15a18,18,0,0,1,2.59,3.14,17.43,17.43,0,0,1,1.76,3.66,14.39,14.39,0,0,1,.47,1.72,12.11,12.11,0,0,1,.26,1.52,12.8,12.8,0,0,1,.1,1.28,6.12,6.12,0,0,1,0,1,4.16,4.16,0,0,1-.06.81c-.07,0,0-1.17-.25-3-.08-.46-.15-1-.29-1.49s-.3-1.1-.49-1.68a18.06,18.06,0,0,0-1.76-3.6,19,19,0,0,0-2.53-3.09,16.56,16.56,0,0,0-1.31-1.16c-.42-.36-.85-.64-1.23-.91C362.34,449.42,361.26,449,361.29,448.91Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '366.56px 457.18px' }}
            id="el0vd9midjcr5"
            className="animable"
          />
          <path
            d="M71.45,442c.92-3.58-1.43-7.17-4-9.77s-5.78-4.92-7.14-8.35c-2.22-5.56.76-12.75-3-17.39C55,403.8,51,402.89,49.05,400a14.91,14.91,0,0,1-1.78-5.21,52.83,52.83,0,0,0-13.16-24.62,45.91,45.91,0,0,0,5.17,23.73c1.53,2.92,3.41,5.76,3.92,9,.82,5.29-2.13,10.73-.83,15.92,1.48,5.94,8.15,9.91,8.47,16,.26,5.16-4.24,9.7-3.9,14.86a14,14,0,0,0,2.29,6.12c4,6.64,9.86,11.21,18.76,11.06l10.89.38Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '56.4626px 418.705px' }}
            id="el8n0pgwyxlx7"
            className="animable"
          />
          <g id="elgivptdo6efb">
            <g style={{ opacity: '0.3', transformOrigin: '56.4626px 418.705px' }} className="animable">
              <path
                d="M71.45,442c.92-3.58-1.43-7.17-4-9.77s-5.78-4.92-7.14-8.35c-2.22-5.56.76-12.75-3-17.39C55,403.8,51,402.89,49.05,400a14.91,14.91,0,0,1-1.78-5.21,52.83,52.83,0,0,0-13.16-24.62,45.91,45.91,0,0,0,5.17,23.73c1.53,2.92,3.41,5.76,3.92,9,.82,5.29-2.13,10.73-.83,15.92,1.48,5.94,8.15,9.91,8.47,16,.26,5.16-4.24,9.7-3.9,14.86a14,14,0,0,0,2.29,6.12c4,6.64,9.86,11.21,18.76,11.06l10.89.38Z"
                id="el0z09fjz9fyk"
                className="animable"
                style={{ transformOrigin: '56.4626px 418.705px' }}
              />
            </g>
          </g>
          <path
            d="M81.08,467.53a8.81,8.81,0,0,0,3-.06,18.74,18.74,0,0,0,3.54-.9A15,15,0,0,0,92,464.18a6,6,0,0,0,1.8-2.4,11.4,11.4,0,0,0,.51-3.25,30.73,30.73,0,0,1,.26-3.52,9.51,9.51,0,0,1,1.33-3.5c1.28-2.26,3.41-4.4,4.1-7.46s.21-6.27-.3-9.54-1-6.83.26-10.24,3.56-6.48,4.75-10.32.63-8.05.89-12.16a16.16,16.16,0,0,1,1.41-6.05c.89-1.92,2.11-3.74,3.06-5.77,1.94-4.1,2.28-8.75,2.81-13.31q.38-3.45.78-7a34.37,34.37,0,0,1,1.21-7,61.88,61.88,0,0,1,2.6-6.74,22.91,22.91,0,0,0,1.27-3.52,36.89,36.89,0,0,0,.35-3.74,44.29,44.29,0,0,0-.29-7.54c-.3-2.51-.75-5-1-7.52,0-.15,0-.3,0-.44l-.06-.5-.44.22a16.86,16.86,0,0,0-5.87,4.95,26.75,26.75,0,0,0-3.6,6.64c-1.82,4.68-2.47,9.58-3.39,14.26s-2.07,9.28-4.47,13.17c-1.2,1.94-2.64,3.71-3.91,5.61a15.44,15.44,0,0,0-2.7,6.2c-.64,4.61,1.9,8.66,1.37,12.73a14.21,14.21,0,0,1-2,5.66c-1,1.74-2.15,3.35-3.25,5a32.62,32.62,0,0,0-2.93,5,15.78,15.78,0,0,0-1.33,5.46c-.27,3.67.25,7.15,0,10.44A24,24,0,0,1,82.44,437c-1.31,2.68-2.78,5.11-4,7.46-.61,1.17-1.18,2.32-1.65,3.47a16.69,16.69,0,0,0-1,3.44,21.39,21.39,0,0,0-.08,6.22,15.61,15.61,0,0,0,3.11,7.92,7.77,7.77,0,0,0,.88,1,4.29,4.29,0,0,0,.72.6c.4.3.62.44.62.44A13.56,13.56,0,0,1,79,465.44a15.65,15.65,0,0,1-3-7.87,21.27,21.27,0,0,1,.14-6.13,16.23,16.23,0,0,1,1-3.36c.46-1.12,1-2.26,1.66-3.42,1.24-2.33,2.72-4.74,4.06-7.44a24.48,24.48,0,0,0,2.79-9.11c.28-3.36-.22-6.85.05-10.44A15.48,15.48,0,0,1,87,412.39a30.55,30.55,0,0,1,2.89-4.92c1.1-1.61,2.27-3.23,3.29-5a14.73,14.73,0,0,0,2.08-5.88c.52-4.35-2-8.42-1.34-12.7a14.79,14.79,0,0,1,2.61-5.94c1.24-1.86,2.7-3.63,3.92-5.62,2.48-4,3.68-8.69,4.58-13.39s1.58-9.56,3.37-14.14a25.79,25.79,0,0,1,3.51-6.46,16,16,0,0,1,5.62-4.75l-.51-.28c0,.14,0,.29,0,.44.28,2.55.73,5.05,1,7.53a43.09,43.09,0,0,1,.29,7.43,35.47,35.47,0,0,1-.33,3.63,23.35,23.35,0,0,1-1.22,3.39,60.71,60.71,0,0,0-2.63,6.82,34.91,34.91,0,0,0-1.23,7.08c-.26,2.34-.51,4.67-.77,7-.52,4.58-.86,9.15-2.72,13.12-.92,2-2.14,3.79-3,5.78a16.93,16.93,0,0,0-1.46,6.27c-.24,4.2.31,8.31-.83,12s-3.5,6.79-4.7,10.31-.75,7.23-.23,10.48,1.05,6.47.35,9.37-2.7,5-4,7.36A10.14,10.14,0,0,0,94.2,455a32.17,32.17,0,0,0-.23,3.57,10.91,10.91,0,0,1-.47,3.16A5.84,5.84,0,0,1,91.81,464a14.86,14.86,0,0,1-4.26,2.41,19.81,19.81,0,0,1-3.49.95,14,14,0,0,1-2.22.21C81.34,467.52,81.08,467.53,81.08,467.53Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '97.3297px 400.145px' }}
            id="eljdd9k4ny9e"
            className="animable"
          />
          <path
            d="M115.49,339.23a1.89,1.89,0,0,0-.1.33c-.07.26-.15.58-.24,1-.22.86-.47,2.15-.88,3.77s-1.42,3.44-2.26,5.69-1.77,4.82-2.59,7.72-1.57,6.13-2.34,9.59a39.85,39.85,0,0,1-3.49,10.63c-.89,1.77-1.89,3.56-2.69,5.52a25.69,25.69,0,0,0-1.57,6.25A124,124,0,0,1,97,402.89l-6.15,25.16c-1.94,7.72-3.69,14.67-5.17,20.53s-2.59,10.52-3.42,13.85c-.38,1.59-.67,2.86-.89,3.77-.09.4-.16.73-.22,1a1.72,1.72,0,0,0,0,.34,1.72,1.72,0,0,0,.12-.32c.08-.26.17-.58.28-1,.25-.91.59-2.16,1-3.74.87-3.32,2.11-8,3.63-13.8s3.32-12.79,5.31-20.49,4-16.24,6.22-25.17A125.68,125.68,0,0,0,100,389.81a24.78,24.78,0,0,1,1.51-6.1c.77-1.91,1.76-3.69,2.65-5.48,1.92-3.55,2.71-7.36,3.48-10.8s1.45-6.68,2.24-9.58,1.64-5.48,2.48-7.71,1.76-4.09,2.16-5.76.58-2.94.76-3.81c.07-.41.12-.73.17-1A1.45,1.45,0,0,0,115.49,339.23Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '98.3158px 403.385px' }}
            id="elce98h24exuq"
            className="animable"
          />
          <path
            d="M83,467.56c7.12-4.22,9.16-17.06,6.19-24.78s-8.16-14.79-9-23c-.62-6.34,1.46-12.83,0-19-2-8.35-10.14-14.82-10-23.41.06-4.81,2.8-9.35,2.58-14.16-.27-5.9-4.8-10.58-7.61-15.78-4.29-8-4.57-17.37-6-26.29s-4.87-18.49-12.78-22.87c-1.17,7.57-3.16,12.76-2.54,23,.23,3.68,4.51,10.74,5.09,18.82.35,4.83.59,9.66.89,14.49s.59,9.49,2.28,13.89c1.29,3.37,3.36,6.44,4.32,9.92,1.81,6.54-.57,13.64.89,20.27,1.24,5.62,5.13,10.46,5.92,16.16,1.12,8-4.07,16.32-1.41,24,1.31,3.79,4.43,6.83,5.32,10.75.68,3-.07,6.25.56,9.3,1,4.91,10.37,8.73,15.38,8.42"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '67.1158px 382.915px' }}
            id="elr7box421g9s"
            className="animable"
          />
          <path
            d="M48.27,305.75a2.31,2.31,0,0,0,0,.43c0,.32.1.73.16,1.24.17,1.1.35,2.7.72,4.78s1.47,4.44,2.33,7.28,1.81,6.09,2.61,9.74,1.49,7.69,2.21,12,1.49,9.08,3.64,13.61c1,2.27,2.12,4.55,3,7a31.29,31.29,0,0,1,1.5,7.69,154.41,154.41,0,0,0,2.09,16.57c2.17,11.22,4.25,21.92,6.14,31.65L78,443.53c1.53,7.3,2.77,13.22,3.63,17.37.44,2,.78,3.59,1,4.71.12.51.21.91.29,1.22s.1.42.12.41a2.7,2.7,0,0,0-.05-.42c-.06-.32-.13-.73-.22-1.24-.21-1.13-.51-2.72-.89-4.74-.82-4.16-2-10.09-3.41-17.41s-3.21-16.1-5.15-25.81S69.36,397.2,67.21,386a155.52,155.52,0,0,1-2.1-16.52,32.06,32.06,0,0,0-1.55-7.84c-.87-2.47-2-4.76-3-7-2.14-4.46-2.9-9.12-3.66-13.45s-1.45-8.39-2.3-12.05a99.8,99.8,0,0,0-2.72-9.75c-.9-2.85-2-5.18-2.44-7.22s-.63-3.66-.84-4.74c-.09-.51-.17-.92-.23-1.23A1.83,1.83,0,0,0,48.27,305.75Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '65.65px 386.495px' }}
            id="el6dywozf7ta9"
            className="animable"
          />
        </g>
        <g id="freepik--Device--inject-42" className="animable" style={{ transformOrigin: '199.975px 261.195px' }}>
          <path
            d="M269,467.23H129.83c-16.82-.07-31-14.41-31-31.23l1.48-350.51A30.46,30.46,0,0,1,131,55.16l139.81.65a30.44,30.44,0,0,1,30.31,30.58l-1.48,350.52A30.45,30.45,0,0,1,269,467.23Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '199.975px 261.195px' }}
            id="elv2u9vofw4uq"
            className="animable"
          />
          <path
            d="M270.87,69.13,243.76,69a6.74,6.74,0,0,0-6.61,6.85l0,4.92a6.74,6.74,0,0,1-6.61,6.85l-52.84-.24a6.73,6.73,0,0,1-6.55-6.91l0-4.92a6.74,6.74,0,0,0-6.56-6.91l-9.53,0-23.73-.11a21.33,21.33,0,0,0-21.42,21.24l-1.45,342.13a21.32,21.32,0,0,0,21.23,21.42l139.53.64a21.32,21.32,0,0,0,21.43-21.24L292.1,90.55A21.33,21.33,0,0,0,270.87,69.13Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '200.28px 261.245px' }}
            id="elq8ppz2zxjgj"
            className="animable"
          />
          <path
            d="M211.65,389.26c-.16,4.13-.31,8-.44,11.23h20l-2.45-12.31Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '221.21px 394.335px' }}
            id="elw9fpt21ypm"
            className="animable"
          />
          <path
            d="M130.19,394.41l.17,6.08h78.85c.13-3.41.28-7.2.43-11.1Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '169.915px 394.94px' }}
            id="elho7he1d7luk"
            className="animable"
          />
          <polygon
            points="229.81 388.11 232.27 400.49 269.23 400.49 268.78 385.65 229.81 388.11"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '249.52px 393.07px' }}
            id="elxmd6x54vmmi"
            className="animable"
          />
          <polygon
            points="213.65 215.12 220.64 174.61 202.34 173.25 202.34 215.12 213.65 215.12"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '211.49px 194.185px' }}
            id="elecq2i1za8f7"
            className="animable"
          />
          <polygon
            points="128.54 371.92 108.68 379.7 108.62 393.77 129.13 392.48 128.54 371.92"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '118.875px 382.845px' }}
            id="eleu56qypjp7o"
            className="animable"
          />
          <polygon
            points="128.45 368.76 127.36 331.03 127.35 331.03 127.35 317.73 108.93 319.68 108.69 376.48 128.44 368.74 128.45 368.76"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '118.57px 347.105px' }}
            id="el13foumwswr88"
            className="animable"
          />
          <polygon
            points="127.35 288.02 109.08 285.61 108.95 316.66 127.35 314.71 127.35 288.02"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '118.15px 301.135px' }}
            id="elb6mw65af7"
            className="animable"
          />
          <polygon
            points="263.54 318.29 262.77 329.1 241.19 331.43 242.86 339.98 267.35 338.13 266.99 325.87 268.94 317.74 263.54 318.29"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '255.065px 328.86px' }}
            id="elols45gawoxr"
            className="animable"
          />
          <polygon
            points="224.64 341.35 241.85 340.06 238.1 320.85 223.08 322.37 224.64 341.35"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '232.465px 331.1px' }}
            id="el38cfuxabgst"
            className="animable"
          />
          <polygon
            points="224.81 343.35 226.12 359.36 228.46 381.33 229.41 386.13 268.72 383.65 267.41 340.14 224.81 343.35"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '246.765px 363.135px' }}
            id="elb9y1d30xqah"
            className="animable"
          />
          <path
            d="M157.15,267.74l1.51,2.6L128.35,288V330l32-2.26L222,321.47,219.75,294l-58.91-7.7.39-3,58.27,7.61-3.82-46.53L158,249.94l-.19-2,57.7-5.55-2-24.28H158L109.33,227l-.24,55.59L127.54,285ZM131.45,326s.23-34.59,0-35.88l24.74-13.16,3.21,47.27Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '165.545px 274.055px' }}
            id="elndznetg7ylc"
            className="animable"
          />
          <polygon
            points="261.51 318.49 239.1 320.75 240.8 329.46 260.89 327.29 261.51 318.49"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '250.305px 323.975px' }}
            id="elvf08mw72sgc"
            className="animable"
          />
          <path
            d="M211.93,381.85c-.07,1.82-.14,3.63-.2,5.4l16.68-1.05-.86-4.31Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '220.07px 384.55px' }}
            id="eli90qkvpfc7l"
            className="animable"
          />
          <polygon
            points="176 215.12 178.94 201.8 201.34 201.8 201.34 173.18 131.31 167.99 131.31 194.86 109.44 199.81 109.34 223.94 157.77 215.12 176 215.12"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '155.34px 195.965px' }}
            id="el6l31uaf1xq5"
            className="animable"
          />
          <path
            d="M222.73,135.49l-.6-2.45,26.74-10.58L231.48,87.54a6.22,6.22,0,0,1-1,.08L201,87.48l.8,48.87Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '224.935px 111.915px' }}
            id="elnqo0aovbti"
            className="animable"
          />
          <path
            d="M263.25,116.77l0-47.68L243.76,69a6.74,6.74,0,0,0-6.61,6.85l0,4.92a7,7,0,0,1-2.86,5.64l17.4,34.94Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '248.77px 95.175px' }}
            id="elqw4q6twwvci"
            className="animable"
          />
          <path
            d="M162.73,118.81l-2.26-50.19-5.41,0-21.15-.1-9,44.89ZM157.91,73.7l.72,40.88-28.11-4.11,6.15-36.77Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '143.82px 93.665px' }}
            id="el4d62cekfbi8"
            className="animable"
          />
          <path
            d="M163.75,119v.43c0,3.91.12,11,.18,18.5l36.83-1.5L200,87.48l-22.29-.1a6.73,6.73,0,0,1-6.55-6.91l0-4.92a6.74,6.74,0,0,0-6.56-6.91l-3.11,0L163.74,119Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '181.125px 103.285px' }}
            id="eljkrxtozdt5"
            className="animable"
          />
          <path
            d="M121.93,113l8.92-44.44a21.3,21.3,0,0,0-20.94,21.21l-.1,22.16.1-.65Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '120.33px 90.78px' }}
            id="elspwz68g5ur9"
            className="animable"
          />
          <polygon
            points="128.31 167.77 109.58 166.38 109.45 196.73 128.31 192.47 128.31 167.77"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '118.88px 181.555px' }}
            id="eljc1idvpu8lm"
            className="animable"
          />
          <polygon
            points="121.73 113.94 109.81 112.23 109.6 161.37 112.17 161.56 121.73 113.94"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '115.665px 136.895px' }}
            id="el57wb4oxqj24"
            className="animable"
          />
          <polygon
            points="159.56 368.19 159.88 328.73 128.36 330.96 129.48 369.61 159.56 368.19"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '144.12px 349.17px' }}
            id="el66436brx9ed"
            className="animable"
          />
          <path
            d="M165.36,359.08,210,380.46c.54-14,1-27,1-27.87l1,0,.48-.94c.63.32.63.32.3,9.84-.19,5.31-.45,12.38-.72,19.46H227.4l-2.27-21.44-3-37-58.31,5.88Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '195.61px 351.73px' }}
            id="elaq8ktsdzrx5"
            className="animable"
          />
          <polygon
            points="274.75 293.6 274.24 288.4 220.75 293.96 223 321.37 269.19 316.71 274.75 293.6"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '247.75px 304.885px' }}
            id="el5cjoi2v8b5r"
            className="animable"
          />
          <polygon
            points="201.34 204.8 181.35 204.8 179.07 215.12 201.34 215.12 201.34 204.8"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '190.205px 209.96px' }}
            id="eln8ryi2gii6"
            className="animable"
          />
          <path
            d="M266.49,208.28l-50.05-3.46-2,11.82,2.11,25.66,52.78-5.07Zm-48.21,8.34,2.69-7.46,43.47,2.75L267,233.25l-47.2,5.6Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '241.885px 223.56px' }}
            id="elr6i4cvmvbui"
            className="animable"
          />
          <polygon
            points="271.68 261.91 269.48 239.22 216.67 244.3 218.66 268.45 271.68 261.91"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '244.175px 253.835px' }}
            id="el1xia30zbufy"
            className="animable"
          />
          <polygon
            points="129.19 394.48 108.7 395.77 108.62 394.44 108.59 400.49 129.36 400.49 129.19 394.48"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '118.975px 397.465px' }}
            id="el9o8s5793ub"
            className="animable"
          />
          <path
            d="M291.73,105.5l.3.76.07-15.71a21.33,21.33,0,0,0-21.23-21.42l-6.65,0,0,47.27Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '278.16px 92.765px' }}
            id="ellkty2v9ltb"
            className="animable"
          />
          <path
            d="M209.94,381.55l-45.55-21.82-1.61-31.28-1.9.2-.33,40.49-31.05,1.47,0,.91h0l.6,20.87,79.59-5C209.79,385.44,209.87,383.49,209.94,381.55Zm-78.49-8.36,43.46-3.05,28.27,13.12-71.73,3.88Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '169.72px 360.42px' }}
            id="eleu62y84burt"
            className="animable"
          />
          <path
            d="M278.78,158,280.65,147c-16.34-5.83-17.47-22.87-17.42-28l-10.67,4.22,16.06,32.23Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '266.605px 138.5px' }}
            id="eltj69p63ht7"
            className="animable"
          />
          <polygon
            points="220.5 290.97 242.71 288.66 238.34 269.04 218.9 271.44 220.5 290.97"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '230.805px 280.005px' }}
            id="elsb27a3b6sm"
            className="animable"
          />
          <polygon
            points="266.56 174.95 225.08 174.94 221.64 174.68 216.95 201.85 266.19 205.25 265.05 193.44 269.9 176 266.56 174.95"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '243.425px 189.965px' }}
            id="elpxtdwvnq6qr"
            className="animable"
          />
          <path
            d="M265.55,170l.52-13-16.3-32.73-25.28,10L233.18,170Zm-16.77-41.71,14.94,28.42-2.16,8.85-25.56-1-6.39-26.88Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '245.28px 147.135px' }}
            id="ellkzbils7j78"
            className="animable"
          />
          <polygon
            points="272 326.39 272.77 351.85 290.74 350.84 290.8 351.84 272.8 352.85 273.71 383.33 290.71 382.26 290.83 384.25 273.77 385.33 274.23 400.49 290.79 400.49 291.15 315.5 274.21 317.21 272 326.39"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '281.575px 357.995px' }}
            id="eld1zca7ykgfv"
            className="animable"
          />
          <path
            d="M162.76,119.83l-38.06-5.47-9.52,47.42,47.75,3.54C163.12,158,163,135.63,162.76,119.83Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '139.102px 139.84px' }}
            id="elinkzites26r"
            className="animable"
          />
          <polygon
            points="225.36 169.95 231.12 169.95 222.97 136.48 201.79 137.35 202.3 168.24 225.36 169.95"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '216.455px 153.215px' }}
            id="elbl2aqple1d"
            className="animable"
          />
          <path
            d="M108.49,424.83l0,7c0,.22,0,.43,0,.64Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '108.49px 428.65px' }}
            id="elvt1560505w"
            className="animable"
          />
          <path
            d="M163.9,165.39l37.39,2.77-.5-30.77L164,138.89C164,149.3,164.06,160.4,163.9,165.39Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '182.595px 152.775px' }}
            id="el20v99frusef"
            className="animable"
          />
          <polygon
            points="271.97 264.9 239.33 268.92 243.72 288.56 273.95 285.41 271.97 264.9"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '256.64px 276.73px' }}
            id="elv27prhojxe"
            className="animable"
          />
          <path
            d="M280.82,146l2.09-12.41,9,.7.12-26.71-27.79,11C263.67,137.32,275.48,143.93,280.82,146Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '278.125px 126.79px' }}
            id="elcb1nbe6y20h"
            className="animable"
          />
          <polygon
            points="270.12 193.89 271.25 205.6 291.61 207.01 291.71 182.89 274.67 177.5 270.12 193.89"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '280.915px 192.255px' }}
            id="elbz8xjhhi7tr"
            className="animable"
          />
          <path
            d="M279.8,294l-5.34,22.23,16.69-1.69.1-23.3c-5.12-1.35-9.59-2.45-12-2.92Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '282.855px 302.275px' }}
            id="elq6yz423nbdh"
            className="animable"
          />
          <polygon
            points="268.54 170.32 291.73 177.65 291.79 164.46 269.01 158.57 268.54 170.32"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '280.165px 168.11px' }}
            id="el06gk88ogz8sx"
            className="animable"
          />
          <path
            d="M279,285.22c1.87.28,5.41,1,12.3,2.85l.22-51-17,1.64Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '283.02px 262.57px' }}
            id="el0eh53smughu5"
            className="animable"
          />
          <polygon
            points="274.27 236.75 291.49 235.09 291.59 210.02 271.54 208.63 274.27 236.75"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '281.565px 222.69px' }}
            id="elxpz83ahz1u"
            className="animable"
          />
          <path
            d="M282.74,146.58q4.89,1.48,9.11,2.32l0-12.65-7.33-.57Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '287.295px 142.29px' }}
            id="elxs4jvanmnwa"
            className="animable"
          />
          <path
            d="M280.73,158.5l11.07,2.87.05-11.44c-2.87-.57-6-1.35-9.28-2.36Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '286.29px 154.47px' }}
            id="elpoqefvyw9u"
            className="animable"
          />
          <path
            d="M290.83,384.25l-.12-2-17,1.07-.91-30.48,18-1-.06-1-18,1L272,326.39l2.21-9.18,16.94-1.71v-1l-16.69,1.69L279.8,294l-.55-5.68c2.41.47,6.88,1.57,12,2.92v-3.12c-6.89-1.81-10.43-2.57-12.3-2.85l-4.5-46.48,17-1.64v-2l-17.22,1.66-2.73-28.12,20,1.39,0-3-20.36-1.41-1.13-11.71,4.55-16.39,17,5.39,0-5.24-23.19-7.32.47-11.76,22.78,5.89v-3.09l-11.07-2.87,1.84-10.93c3.32,1,6.41,1.79,9.28,2.36v-1q-4.22-.84-9.11-2.32l1.83-10.9,7.33.57v-2l-9-.7L280.82,146c-5.34-2-17.15-8.63-16.58-27.42l27.79-11v-1.27l-.3-.76-27.48,10.87,0-47.27h-1l0,47.68-11.58,4.58-17.4-34.94a6.34,6.34,0,0,1-2.79,1.13l17.39,34.92L222.13,133l.6,2.45-21,.86L201,87.48h-1l.8,48.91-36.83,1.5c-.06-7.54-.14-14.59-.18-18.5V119h0l-2.26-50.34h-1l2.26,50.19-37.83-5.43,9-44.89h-2.58c-.16,0-.32,0-.48,0L121.93,113l-12-1.72-.1.65v.35l11.92,1.71-9.56,47.62-2.57-.19,0,5,18.73,1.39v24.7l-18.86,4.26v3.08l21.87-4.95V168l70,5.19V201.8h-22.4L176,215.12H157.77l-48.43,8.81V227L158,218.12h55.48l2,24.28L157.81,248l.19,2,57.68-5.55,3.82,46.53-58.27-7.61-.39,3,58.91,7.7L222,321.47l-61.67,6.23-32,2.26V288l30.31-17.68-1.51-2.6L127.54,285l-18.45-2.44v3L127.35,288v26.69l-18.4,2,0,3,18.42-2V331h0l1.09,37.73v0l-19.75,7.74v3.22l19.86-7.78.59,20.56-20.51,1.29v.67l.08,1.33,20.49-1.29.17,6h1l-.17-6.08,79.45-5c-.15,3.9-.3,7.69-.43,11.1h2c.13-3.22.28-7.1.44-11.23l17.15-1.08,2.45,12.31h1l-2.46-12.38,39-2.46.45,14.84h5m-62.5-13.24c.06-1.77.13-3.58.2-5.4l15.62,0,.86,4.31Zm17.68-1.12-1-4.8-2.33-22-1.31-16,42.6-3.21,1.31,43.51Zm9.69-65.38,22.42-2.26-.63,8.8-20.09,2.17Zm-1,.1,3.75,19.21-17.21,1.29-1.56-19Zm29.25,17.29L242.86,340l-1.67-8.55,21.58-2.33.76-10.81,5.41-.55L267,325.87Zm-29-69.1,4.37,19.62L220.5,291l-1.6-19.53Zm5.38,19.52-4.39-19.64,32.64-4,2,20.51Zm22.47-83.31L217,201.85l4.69-27.17,3.44.26h41.49L269.9,176l-4.85,17.44Zm-3-86.32c-.05,5.15,1.08,22.19,17.42,28L278.78,158l-10.16-2.62-16.06-32.23Zm-13.46,5.32L266.07,157l-.52,13H233.18l-8.69-35.69ZM223,136.48,231.12,170h-5.76l-23.06-1.71-.51-30.89Zm-22.18.91.5,30.77-37.39-2.77c.16-5,.13-16.09,0-26.5Zm-76.09-23,38.06,5.47c.19,15.8.36,38.19.17,45.49l-47.75-3.54Zm95.94,60.25-7,40.51H202.34V173.25ZM181.35,204.8h20v10.32H179.07Zm33.05,11.84,2-11.82,50.05,3.46,2.8,28.95-52.78,5.07Zm55.08,22.58,2.2,22.69-53,6.54-2-24.15ZM220.75,294l53.49-5.56.51,5.2-5.56,23.11L223,321.37Zm4.38,65.5,2.27,21.44H212c.27-7.08.53-14.15.72-19.46.33-9.52.33-9.52-.3-9.84l-.48.94-1,0c0,.83-.43,13.9-1,27.87l-44.62-21.38-1.58-30.73,58.31-5.88Zm-65.26-30.73-.31,39.46-30.08,1.42L128.36,331Zm-30.34,42.81h0l0-.91,31.05-1.47.33-40.49,1.9-.2,1.61,31.28,45.55,21.82c-.07,1.94-.15,3.89-.22,5.83l-79.59,5Z"
            style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '200.34px 234.51px' }}
            id="eleiqfisaxwjo"
            className="animable"
          />
          <polygon
            points="174.91 370.14 131.45 373.19 131.45 387.14 203.19 383.25 174.91 370.14"
            style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '167.32px 378.64px' }}
            id="el1qv19det4in"
            className="animable"
          />
          <polygon
            points="264.44 211.91 220.97 209.16 218.28 216.62 219.75 238.85 266.95 233.25 264.44 211.91"
            style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '242.615px 224.005px' }}
            id="el9b1ul3nz0tb"
            className="animable"
          />
          <path
            d="M108.59,387.25l-.1,37.58v7.66a21.31,21.31,0,0,0,21.2,20.78l139.53.64a21.32,21.32,0,0,0,21.43-21.24l.14-45.42Z"
            style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '199.64px 420.58px' }}
            id="elwqh4cacuxm"
            className="animable"
          />
          <polygon
            points="158.63 114.58 157.91 73.7 136.68 73.7 130.52 110.47 158.63 114.58"
            style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '144.575px 94.14px' }}
            id="el3ylldv0hiix"
            className="animable"
          />
          <polygon
            points="261.56 165.51 263.72 156.66 248.78 128.24 229.61 137.67 236 164.55 261.56 165.51"
            style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '246.665px 146.875px' }}
            id="elu3dp19lxwn"
            className="animable"
          />
          <path
            d="M131.45,290.08c.23,1.29,0,35.88,0,35.88l28-1.77-3.21-47.27Z"
            style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '145.45px 301.44px' }}
            id="el5o9zkpa59eu"
            className="animable"
          />
          <polygon
            points="224.65 318.17 223.17 296.73 271.1 290.57 271.1 294.27 265.3 313.98 224.65 318.17"
            style={{ fill: 'rgb(235, 235, 235)', transformOrigin: '247.135px 304.37px' }}
            id="eln9hd8r2w2d8"
            className="animable"
          />
          <path
            d="M269.33,372.77l-.6-14-42.13,2a6.38,6.38,0,0,1-3.19-.68L163.66,330a4.33,4.33,0,0,1-2.37-3.64l-8.13-157.73a2.62,2.62,0,0,1,.79-2,2.65,2.65,0,0,1,2-.74l25.6,1.9v-28h3v28.38a2.63,2.63,0,0,1-.84,1.94,2.66,2.66,0,0,1-2,.7l-25.59-1.9,8.12,157.33a1.34,1.34,0,0,0,.72,1.12l59.76,30.17a3.27,3.27,0,0,0,1.68.36l42.48-2.06a2.61,2.61,0,0,1,1.92.69,2.64,2.64,0,0,1,.86,1.84l.61,14.33Z"
            style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '212.714px 256.28px' }}
            id="el2p0nqke4s2i"
            className="animable"
          />
          <path
            d="M257,122.6a5.84,5.84,0,1,1-5.84-5.84A5.83,5.83,0,0,1,257,122.6Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '251.16px 122.6px' }}
            id="el19hq8vnrm7u"
            className="animable"
          />
          <g id="el13vzq8303sdh">
            <g style={{ opacity: '0.6', transformOrigin: '251.11px 122.6px' }} className="animable">
              <g id="ele1g13wxbufh">
                <circle
                  cx="251.11"
                  cy="122.6"
                  r="5.84"
                  style={{
                    fill: 'rgb(255, 255, 255)',
                    transformOrigin: '251.11px 122.6px',
                    transform: 'rotate(-31.64deg)',
                  }}
                  className="animable"
                />
              </g>
            </g>
          </g>
          <path
            d="M255,122.4a3.89,3.89,0,1,1-3.89-3.88A3.89,3.89,0,0,1,255,122.4Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '251.11px 122.41px' }}
            id="elhq16ng2d6e8"
            className="animable"
          />
          <path
            d="M270.59,374.91l-.72-16.38a.89.89,0,0,0-.93-.85L225,360l-5.29-66.64L213,216.6v-.07l7.51-41a3.25,3.25,0,0,1,3.19-2.67l39.73-.13a2.84,2.84,0,0,0,2.83-2.66l.68-11a8.23,8.23,0,0,0-.8-4.08l-15.52-32.38.91-.43,15.52,32.38a9.26,9.26,0,0,1,.89,4.58l-.68,11a3.85,3.85,0,0,1-3.83,3.59l-39.73.13a2.24,2.24,0,0,0-2.21,1.85L214,216.64l6.61,76.6,5.22,65.68,43-2.23a1.81,1.81,0,0,1,1.36.48,1.85,1.85,0,0,1,.62,1.31l.72,16.39Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '242.265px 248.545px' }}
            id="elyd36vbkqm7"
            className="animable"
          />
          <path
            d="M273.32,373.58a2.5,2.5,0,1,1-2.49-2.49A2.49,2.49,0,0,1,273.32,373.58Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '270.82px 373.59px' }}
            id="el3qvkgstc5a7"
            className="animable"
          />
          <path
            d="M225.2,327.45a2.34,2.34,0,1,1-2.5-2.18A2.34,2.34,0,0,1,225.2,327.45Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '222.865px 327.604px' }}
            id="el6yfyus6esw4"
            className="animable"
          />
          <path
            d="M223.08,329.43a4.23,4.23,0,0,0-3.93,4.51l8.44-.58A4.23,4.23,0,0,0,223.08,329.43Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '223.365px 331.68px' }}
            id="eljj49hsfgf9"
            className="animable"
          />
          <path
            d="M256.4,302.6H235.64a3.17,3.17,0,0,0-3.17,3.17v13a3.16,3.16,0,0,0,3.17,3.16h.42v3.11l3.6-3.11H256.4a3.16,3.16,0,0,0,3.17-3.16v-13A3.17,3.17,0,0,0,256.4,302.6Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '246.02px 313.82px' }}
            id="elwzyabs2e"
            className="animable"
          />
          <g id="elkbf8bv3t5uo">
            <g style={{ opacity: '0.4', transformOrigin: '246.02px 313.82px' }} className="animable">
              <path
                d="M256.4,302.6H235.64a3.17,3.17,0,0,0-3.17,3.17v13a3.16,3.16,0,0,0,3.17,3.16h.42v3.11l3.6-3.11H256.4a3.16,3.16,0,0,0,3.17-3.16v-13A3.17,3.17,0,0,0,256.4,302.6Z"
                style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '246.02px 313.82px' }}
                id="el7wnr5bc5k2p"
                className="animable"
              />
            </g>
          </g>
          <path
            d="M242.23,312.82v1.7h-.7V312.8l-2-3.21h.76l1.58,2.6,1.58-2.6h.7Z"
            style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '241.84px 312.055px' }}
            id="eldh91hyhlgem"
            className="animable"
          />
          <path
            d="M244,312.65a1.95,1.95,0,1,1,1.95,1.91A1.86,1.86,0,0,1,244,312.65Zm3.2,0A1.26,1.26,0,1,0,246,314,1.22,1.22,0,0,0,247.23,312.65Z"
            style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '245.949px 312.611px' }}
            id="eli8ijtrrkjpm"
            className="animable"
          />
          <path
            d="M252.33,310.79v3.73h-.64V314a1.5,1.5,0,0,1-1.27.6,1.46,1.46,0,0,1-1.6-1.62v-2.15h.67v2.07c0,.73.37,1.1,1,1.1a1.1,1.1,0,0,0,1.16-1.24v-1.93Z"
            style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '250.57px 312.699px' }}
            id="el3mfr0q8owrw"
            className="animable"
          />
          <ellipse
            cx="133.31"
            cy="405.07"
            rx="0.26"
            ry="1.5"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '133.31px 405.07px' }}
            id="el036h61543j89"
            className="animable"
          />
          <ellipse
            cx="133.31"
            cy="411.07"
            rx="0.26"
            ry="1.5"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '133.31px 411.07px' }}
            id="elvf2kh22xp9"
            className="animable"
          />
          <ellipse
            cx="133.31"
            cy="417.07"
            rx="0.26"
            ry="1.5"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '133.31px 417.07px' }}
            id="elk0o0a6qi9n"
            className="animable"
          />
          <ellipse
            cx="133.31"
            cy="423.07"
            rx="0.26"
            ry="1.5"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '133.31px 423.07px' }}
            id="eljdcowv19dzr"
            className="animable"
          />
          <ellipse
            cx="133.31"
            cy="428.65"
            rx="0.26"
            ry="1.08"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '133.31px 428.65px' }}
            id="eld7s33w34v37"
            className="animable"
          />
          <path
            d="M137.56,434.87a4.25,4.25,0,1,0-7.91,2.15h0c.16.28.37.47.57.76l2.47,3.27a.77.77,0,0,0,1.23,0l2.42-3.21A10,10,0,0,0,137,437h0A4.24,4.24,0,0,0,137.56,434.87Zm-4.25,1.85a1.87,1.87,0,1,1,1.87-1.87A1.87,1.87,0,0,1,133.31,436.72Z"
            style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '133.31px 435.983px' }}
            id="el5mfswfy030e"
            className="animable"
          />
          <path
            d="M241.19,436.72c0,.14-21.56.26-48.14.26s-48.14-.12-48.14-.26,21.55-.26,48.14-.26S241.19,436.58,241.19,436.72Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '193.05px 436.72px' }}
            id="elb29zm4l7af4"
            className="animable"
          />
          <path
            d="M203.18,432.5c0,.14-13.06.26-29.16.26s-29.17-.12-29.17-.26,13.05-.26,29.17-.26S203.18,432.35,203.18,432.5Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '174.015px 432.5px' }}
            id="elvflruavw3r"
            className="animable"
          />
          <path
            d="M160.64,441.5a58.09,58.09,0,0,1-7.71.26,58.31,58.31,0,0,1-7.72-.26,56.33,56.33,0,0,1,7.72-.26A56.12,56.12,0,0,1,160.64,441.5Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '152.925px 441.498px' }}
            id="els4zaz04oq1o"
            className="animable"
          />
          <path
            d="M137.56,401.72a4.25,4.25,0,1,0-7.91,2.15h0v0c.16.27.37.47.57.76l2.47,3.26a.77.77,0,0,0,1.23,0l2.42-3.21a10,10,0,0,0,.62-.82h0A4.22,4.22,0,0,0,137.56,401.72Zm-4.25,1.85a1.87,1.87,0,1,1,1.87-1.87A1.87,1.87,0,0,1,133.31,403.57Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '133.31px 402.828px' }}
            id="el3frbwxjf3x4"
            className="animable"
          />
          <path
            d="M261.52,403.57c0,.15-26.11.26-58.31.26s-58.3-.11-58.3-.26,26.1-.26,58.3-.26S261.52,403.43,261.52,403.57Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '203.215px 403.57px' }}
            id="el8zpcr6ef8ju"
            className="animable"
          />
          <path
            d="M227.4,399.35c0,.15-18.48.26-41.27.26s-41.28-.11-41.28-.26,18.48-.26,41.28-.26S227.4,399.21,227.4,399.35Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '186.125px 399.35px' }}
            id="ely7vu1ob46u"
            className="animable"
          />
          <path
            d="M190.45,408.35c0,.14-10.12.26-22.61.26s-22.63-.12-22.63-.26,10.13-.26,22.63-.26S190.45,408.21,190.45,408.35Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '167.83px 408.35px' }}
            id="elf0bqjffrlhj"
            className="animable"
          />
        </g>
        <g
          id="freepik--speech-bubble--inject-42"
          className="animable"
          style={{ transformOrigin: '425.979px 132.414px' }}
        >
          <path
            d="M428.45,163.42l-4.56-10.15a25.89,25.89,0,1,1,9.25-.92h0Z"
            style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '425.994px 132.498px' }}
            id="elm5b9233v56"
            className="animable"
          />
          <path
            d="M428.45,163.42c.34-.84,1.72-4.18,4.58-11.12l.12.18h0l-1,0,1-.28a25.77,25.77,0,0,0,11.42-6.92,23,23,0,0,0,2.54-3.16c.38-.58.78-1.17,1.16-1.78l1-1.94a25.59,25.59,0,0,0-13.6-34.67A25.18,25.18,0,0,0,423.94,102a25.67,25.67,0,0,0-11.46,3.76,26.25,26.25,0,0,0-8.18,8.17,25.08,25.08,0,0,0-3.72,10.28,25.93,25.93,0,0,0,4.81,18.61,27.88,27.88,0,0,0,6,5.85,25.71,25.71,0,0,0,12.49,4.51H424l0,.07c2.77,6.38,4.09,9.4,4.44,10.2-.37-.79-1.75-3.78-4.67-10.1l.1.07a25.7,25.7,0,0,1-12.67-4.47,27.73,27.73,0,0,1-6.15-5.9,26.28,26.28,0,0,1-4.95-18.91,25.61,25.61,0,0,1,3.77-10.49,26,26,0,0,1,20-12.18,25.65,25.65,0,0,1,11.91,1.83,26.47,26.47,0,0,1,9.5,6.59,25.91,25.91,0,0,1,5.5,9.48,26.17,26.17,0,0,1-1.22,19.26c-.34.66-.69,1.31-1,2s-.79,1.21-1.18,1.8a22.28,22.28,0,0,1-2.6,3.19,25.83,25.83,0,0,1-11.61,6.92l0-.25h.22l-.08.19C430.26,159.27,428.81,162.59,428.45,163.42Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '425.979px 132.414px' }}
            id="elrxmas48svvp"
            className="animable"
          />
          <path
            d="M437,126.5a9.74,9.74,0,1,0-18.13,4.92h0l0,0c.37.63.84,1.08,1.31,1.74l5.65,7.49a1.76,1.76,0,0,0,2.81,0l5.56-7.37a20.64,20.64,0,0,0,1.41-1.87l0,0h0A9.64,9.64,0,0,0,437,126.5Zm-9.73,4.24a4.29,4.29,0,1,1,4.28-4.28A4.29,4.29,0,0,1,427.24,130.74Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '427.26px 129.041px' }}
            id="el3w3sg2bdnee"
            className="animable"
          />
        </g>
        <g id="freepik--Character--inject-42" className="animable" style={{ transformOrigin: '359.23px 288.423px' }}>
          <path
            d="M355.48,116c.9-3.33,3.41-5,6.68-6.09a10.76,10.76,0,0,1,9.82,1.6c1.84,1.39,3.28,3.43,5.46,4.19,3.59,1.25,7.8-1.44,11.25.17a4.9,4.9,0,0,1-2.32,9.34c2.34.86,3.07,4.2,1.7,6.29s-4.18,2.87-6.64,2.41A13.72,13.72,0,0,1,375,130.3c-1.85-1.67-3.52-3.56-5.5-5.07a10.71,10.71,0,0,0-6.88-2.53c-3.38.18-6.27,2.73-7.78,5.75s-1.85,6.49-2,9.86-.25,6.8-1.25,10c-.12.38-.3.8-.68.92-.54.17-1-.41-1.28-.92a49.63,49.63,0,0,1-5.67-18.43c-.38-3.74-.28-7.28,1.77-10.43s7.25-5.46,9.8-3.48"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '367.659px 129.313px' }}
            id="eld68g3p65d4p"
            className="animable"
          />
          <path
            d="M349,131.66l-1.73,37.85c-.29,6.44.59,16,10.79,16h0c8.85-.66,11.46-8.93,11.73-14.94.13-2.85.24-5.23.27-5.52,0,0,9.68-.46,10.81-10,.55-4.59.9-14.15,1.12-22.79A17.83,17.83,0,0,0,366,114.06l-.92-.1C355.13,113.49,349.16,121.69,349,131.66Z"
            style={{ fill: 'rgb(255, 190, 157)', transformOrigin: '364.611px 149.725px' }}
            id="el6rx08dc4bf4"
            className="animable"
          />
          <path
            d="M370.05,164.87A22.25,22.25,0,0,1,358,160s2.2,7.16,11.79,7.32Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '364.025px 163.66px' }}
            id="elo35w42ivyij"
            className="animable"
          />
          <path
            d="M379.5,139.32a1.36,1.36,0,0,1-1.46,1.23,1.31,1.31,0,0,1-1.27-1.37,1.38,1.38,0,0,1,1.46-1.24A1.31,1.31,0,0,1,379.5,139.32Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '378.135px 139.246px' }}
            id="elzgsczx10ui9"
            className="animable"
          />
          <path
            d="M379.41,136.69c-.19.16-1.13-.71-2.6-.86s-2.61.46-2.75.27.14-.39.64-.68a3.77,3.77,0,0,1,2.23-.44,3.56,3.56,0,0,1,2,.91C379.38,136.28,379.5,136.62,379.41,136.69Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '376.731px 135.833px' }}
            id="elqztyxq5mi3"
            className="animable"
          />
          <path
            d="M365.1,138.29a1.36,1.36,0,0,1-1.45,1.23,1.3,1.3,0,0,1-1.27-1.37,1.36,1.36,0,0,1,1.45-1.24A1.31,1.31,0,0,1,365.1,138.29Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '363.74px 138.215px' }}
            id="elxuwvuyxzut"
            className="animable"
          />
          <path
            d="M365,135.43c-.18.16-1.13-.71-2.59-.86s-2.62.47-2.76.27.14-.39.64-.68a3.77,3.77,0,0,1,2.23-.44,3.63,3.63,0,0,1,2,.91C365,135,365.1,135.36,365,135.43Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '362.325px 134.573px' }}
            id="elifagpkm8ay"
            className="animable"
          />
          <path
            d="M369.16,146.85a9.16,9.16,0,0,1,2.42-.18c.38,0,.74,0,.83-.28a2,2,0,0,0-.13-1.14c-.26-.94-.52-1.92-.8-3-1.11-4.21-1.86-7.66-1.69-7.7s1.2,3.34,2.3,7.55c.26,1,.52,2,.75,3a2.16,2.16,0,0,1,0,1.49.93.93,0,0,1-.67.48,2.36,2.36,0,0,1-.64,0A10.09,10.09,0,0,1,369.16,146.85Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '371.066px 140.821px' }}
            id="elte3p6p2sixr"
            className="animable"
          />
          <path
            d="M366,129.74c-.18.38-1.62,0-3.36.07s-3.18.34-3.37,0c-.08-.18.2-.53.8-.86a5.75,5.75,0,0,1,2.56-.6,5.68,5.68,0,0,1,2.57.58C365.79,129.21,366.07,129.56,366,129.74Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '362.634px 129.164px' }}
            id="el28blvs9b8uli"
            className="animable"
          />
          <path
            d="M379.32,132.4c-.29.31-1.26-.15-2.47-.29s-2.26,0-2.46-.39c-.09-.18.11-.49.59-.76a3.45,3.45,0,0,1,2.07-.33,3.41,3.41,0,0,1,1.91.88C379.35,131.89,379.45,132.25,379.32,132.4Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '376.871px 131.548px' }}
            id="eljq3etvzhnwj"
            className="animable"
          />
          <path
            d="M349,138.79c-.15-.09-6.33-2.63-6.81,3.9s6.17,5.67,6.19,5.48S349,138.79,349,138.79Z"
            style={{ fill: 'rgb(255, 190, 157)', transformOrigin: '345.583px 143.271px' }}
            id="elxp0erzre5fh"
            className="animable"
          />
          <path
            d="M346.55,145.55s-.12.07-.32.14a1.11,1.11,0,0,1-.85,0,2.81,2.81,0,0,1-1.11-2.62,3.63,3.63,0,0,1,.44-1.61,1.31,1.31,0,0,1,.92-.81.57.57,0,0,1,.64.36c.08.19,0,.32.06.33s.15-.09.12-.37a.8.8,0,0,0-.23-.43.85.85,0,0,0-.62-.21,1.62,1.62,0,0,0-1.26.92,3.88,3.88,0,0,0-.53,1.8,3,3,0,0,0,1.45,2.94,1.22,1.22,0,0,0,1.05-.1C346.53,145.71,346.57,145.56,346.55,145.55Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '345.172px 143.196px' }}
            id="el3u672bcgihs"
            className="animable"
          />
          <path
            d="M384.18,130.48a13.85,13.85,0,0,1-11.92-4c-2.11-2.21-3.59-5.23-6.4-6.43a7.77,7.77,0,0,0-6,.18,15.12,15.12,0,0,0-4.92,3.64c1.33,5-.48,10.3-2.27,15.19a2.62,2.62,0,0,1-.92,1.42c-.83.51-1.93-.07-2.53-.85a8.08,8.08,0,0,1-1.31-4.43,26.83,26.83,0,0,1,1.18-10.54,18.34,18.34,0,0,1,6-8.67,17.35,17.35,0,0,1,12.6-3.29,21.26,21.26,0,0,1,11.82,5.71,12.49,12.49,0,0,1,3.51,5"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '365.994px 126.614px' }}
            id="el8tvmt626rtf"
            className="animable"
          />
          <path
            d="M369.61,151a6.58,6.58,0,0,1-.84,1.65,2.19,2.19,0,0,1-1.56.91,2,2,0,0,1-1.67-.91,3.19,3.19,0,0,1-.46-1.89c0-.6.3-1.31.89-1.38a1.41,1.41,0,0,1,.72.16l3.12,1.26"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '367.441px 151.469px' }}
            id="elojh2ia6thb"
            className="animable"
          />
          <path
            d="M368.36,153.55a4.52,4.52,0,0,1-1.66-.21,2.45,2.45,0,0,1-1.26-1.14,2.53,2.53,0,0,1,0-2,2.43,2.43,0,0,1,.28-.47c.12-.13.1-.12.23-.1s.33.13.5.19.35.15.51.21c.67.27,1.27.51,1.78.7a5.81,5.81,0,0,0,1.7.51,5.6,5.6,0,0,0-1.54-.87c-.49-.24-1.08-.51-1.74-.81l-.5-.22a4.67,4.67,0,0,0-.57-.24.81.81,0,0,0-.46,0,.85.85,0,0,0-.35.28,2.49,2.49,0,0,0-.35.59,2.91,2.91,0,0,0,.1,2.49,2.63,2.63,0,0,0,1.58,1.28,2.52,2.52,0,0,0,1.35,0C368.23,153.68,368.38,153.58,368.36,153.55Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '367.569px 151.449px' }}
            id="el7snlrtuofy8"
            className="animable"
          />
          <path
            d="M427.06,422.78l7.29,21.14s23.93-.3,25.66,3.47L419.52,463l-12.7-32.48Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '433.415px 442.89px' }}
            id="el97jseklustl"
            className="animable"
          />
          <path
            d="M421.15,447a1.77,1.77,0,0,0-.41,2.33,1.7,1.7,0,0,0,2.3.43,1.88,1.88,0,0,0,.43-2.47,1.77,1.77,0,0,0-2.45-.18"
            style={{ fill: 'rgb(224, 224, 224)', transformOrigin: '422.113px 448.367px' }}
            id="eljwo7z6yd97n"
            className="animable"
          />
          <g id="el0k6g9ar6eu55">
            <g style={{ opacity: '0.6', transformOrigin: '439.19px 454.5px' }} className="animable">
              <path
                d="M419.52,463l-1.15-3.32L457.62,446s2.11.09,2.39,1.44Z"
                style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '439.19px 454.5px' }}
                id="elnbf68nfrynk"
                className="animable"
              />
            </g>
          </g>
          <path
            d="M434.92,443.46c.07.2-.88.67-1.61,1.68s-.92,2-1.14,2-.35-1.26.55-2.47S434.9,443.26,434.92,443.46Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '433.467px 445.266px' }}
            id="el4lzcixjxj8f"
            className="animable"
          />
          <path
            d="M439.85,443.58c.12.18-.61.84-1,1.94s-.2,2.05-.4,2.12-.76-1-.3-2.36S439.77,443.39,439.85,443.58Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '438.918px 445.593px' }}
            id="elmaed3zoys3k"
            className="animable"
          />
          <path
            d="M444.22,447.73c-.17.12-.82-.77-.73-2s.85-2.07,1-1.94-.21.93-.27,2S444.41,447.64,444.22,447.73Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '444.004px 445.759px' }}
            id="elb32bpmkcrc"
            className="animable"
          />
          <path
            d="M432.73,438.83c0,.21-1,.29-2.11.79s-1.83,1.2-2,1.07.4-1.16,1.69-1.74S432.77,438.63,432.73,438.83Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '430.661px 439.651px' }}
            id="elyv3l1mstvs"
            className="animable"
          />
          <path
            d="M278.52,420l-.45.59L269.3,432l-10.85,7.44,14.53,28,16,0s-1.15-3.85-8.85-5.84l-.51-15.36,13.82-15.18"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '275.945px 443.72px' }}
            id="elyedpfqag43i"
            className="animable"
          />
          <g id="elrdjicgieoa">
            <g style={{ opacity: '0.6', transformOrigin: '273.715px 452.685px' }} className="animable">
              <polygon
                points="258.45 439.47 272.98 467.46 288.98 467.48 287.18 465.07 274.17 464.35 260.76 437.89 258.45 439.47"
                style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '273.715px 452.685px' }}
                id="el7owgr7b9k3f"
                className="animable"
              />
            </g>
          </g>
          <path
            d="M280,454.6c-.12.17-1-.36-2.28-.32s-2.14.54-2.27.38.76-1.07,2.26-1.09S280.18,454.48,280,454.6Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '277.729px 454.131px' }}
            id="elsd4eg9925a"
            className="animable"
          />
          <path
            d="M279.78,450.79c-.16.12-.88-.83-2.15-1.08s-2.3.33-2.4.17.13-.34.58-.59a3,3,0,0,1,3.66.74C279.79,450.43,279.85,450.75,279.78,450.79Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '277.507px 449.881px' }}
            id="elqooj3v9p53a"
            className="animable"
          />
          <path
            d="M279.88,445.9c-.17.09-.72-.84-1.83-1.22s-2.12,0-2.2-.21.16-.3.61-.47a2.75,2.75,0,0,1,1.82,0,2.8,2.8,0,0,1,1.43,1.14C280,445.56,280,445.86,279.88,445.9Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '277.895px 444.876px' }}
            id="eldh8eba4m9uc"
            className="animable"
          />
          <path
            d="M284.17,442.11c-.19.06-.64-.85-1.63-1.49s-2-.74-2-.94,1.18-.46,2.39.35S284.36,442.08,284.17,442.11Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '282.385px 440.794px' }}
            id="elbbcfyuntgd"
            className="animable"
          />
          <g id="elmicpniwm4cj">
            <g style={{ opacity: '0.6', transformOrigin: '269.32px 439px' }} className="animable">
              <path
                d="M271.22,439a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,271.22,439Z"
                style={{ fill: 'rgb(255, 255, 255)', transformOrigin: '269.32px 439px' }}
                id="eltrwlnv2wuw"
                className="animable"
              />
            </g>
          </g>
          <polygon
            points="331.8 304.8 381.27 377.3 408.01 440.7 430.66 428.59 407.76 365.1 374.12 298.41 331.8 304.8"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '381.23px 369.555px' }}
            id="elycgbgqdj88c"
            className="animable"
          />
          <polygon
            points="311.37 298.41 303.12 356.77 269.35 430.41 289.46 442.11 332.41 369.12 356.25 298.41 311.37 298.41"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '312.8px 370.26px' }}
            id="elltxld99q6a8"
            className="animable"
          />
          <path
            d="M289.46,442.11a1.64,1.64,0,0,1,.18-.35c.13-.25.32-.59.56-1,.51-.91,1.25-2.21,2.19-3.86,1.94-3.37,4.72-8.2,8.16-14.15l27.08-46.57,5.05-8.66,0,.05,14.85-44.71c1.88-5.6,3.4-10.11,4.46-13.25l1.22-3.57.33-.92a1.72,1.72,0,0,1,.13-.31,3.34,3.34,0,0,1-.08.33l-.29.93-1.14,3.6-4.3,13.3c-3.71,11.3-8.87,27-14.69,44.77v0l-5.05,8.66c-10.62,18.15-20.24,34.57-27.21,46.5-3.5,5.91-6.33,10.71-8.3,14.06-1,1.63-1.75,2.91-2.28,3.81l-.61,1A2.9,2.9,0,0,1,289.46,442.11Z"
            style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '321.565px 373.46px' }}
            id="elhzknsgc6ytu"
            className="animable"
          />
          <path
            d="M377.26,266.81l-1.67-25.05-6.34-59.06,2.25-12.31-25-10-3,6c-15,2.26-21.33,31.89-21.33,31.89l-.52,60.25L305,299.37l4.32,3.81c6.83,4.1,70.46,1.52,70.46,1.52Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '342.39px 232.946px' }}
            id="eljl6z377rjb8"
            className="animable"
          />
          <g id="elzfa8j4l8jzp">
            <g style={{ opacity: '0.3', transformOrigin: '336.403px 286.653px' }} className="animable">
              <path
                d="M311.37,283.7a79.17,79.17,0,0,0,15.1,14.61c3.11,2.33,6.79,4.54,10.62,3.93s6.46-3.65,8.89-6.52l13.67-16.12a6.63,6.63,0,0,0,1.77-3.08,4.26,4.26,0,0,0-1.92-3.95,9.2,9.2,0,0,0-4.35-1.43c-9.6-1.14-19,3.63-28.65,3.71-3.3,0-8.68-.63-11.8.46l-3.33,8.39"
                id="elh8wi768tiac"
                className="animable"
                style={{ transformOrigin: '336.403px 286.653px' }}
              />
            </g>
          </g>
          <path
            d="M362.9,244.39a14.77,14.77,0,0,1,1.85,18.88l-8.55,12.51L343.79,292a9.75,9.75,0,0,1-14.58,1l-56.59-43.6a8.46,8.46,0,0,1-1.73-11.61l23-32.38a8.46,8.46,0,0,1,11.82-2Z"
            style={{ fill: 'rgb(69, 90, 100)', transformOrigin: '318.324px 248.823px' }}
            id="elpf0uyi9z3e"
            className="animable"
          />
          <path
            d="M333.59,295.45a1.08,1.08,0,0,1,.15-.3l.5-.85c.45-.74,1.13-1.82,2-3.2,1.79-2.75,4.44-6.71,7.72-11.58s7.23-10.64,11.51-17.12a42.19,42.19,0,0,0,3-5.1,6.49,6.49,0,0,0,.64-2.86,5,5,0,0,0-1.08-2.74c-1.26-1.62-3.15-2.74-4.9-4l-5.41-3.84-37.38-26.66L299.09,209,296,206.81l-.79-.59c-.17-.14-.26-.21-.25-.22a2.31,2.31,0,0,1,.28.18l.82.54,3.11,2.16,11.39,8,37.47,26.53,5.41,3.85c1.74,1.29,3.65,2.4,5,4.14a5.46,5.46,0,0,1,1.17,3,7.06,7.06,0,0,1-.68,3.1,43.77,43.77,0,0,1-3.07,5.15c-4.3,6.48-8.29,12.22-11.6,17.07C337.62,289.4,333.59,295.45,333.59,295.45Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '327.285px 250.725px' }}
            id="elukbezdwfraj"
            className="animable"
          />
          <path
            d="M355.07,168.4s-16.07-8.5-40.34,30l4.3,5s20.27-35.64,33.66-31.33-6.27,60.49-6.27,60.49S375.88,176.56,355.07,168.4Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '338.619px 200.081px' }}
            id="elceo6ye1c396"
            className="animable"
          />
          <path
            d="M301.38,211.72a20.92,20.92,0,0,0-2.81,25.93c.19.29.37.56.56.82L321,272.41l18.3-11.28h0L321.55,229s8.24-8.5,17.2-18.06c12.07-12.89,24.92-28.7,15.71-37.78,0,0-6.27-5-15.92,2.49C331.56,181,311.79,201.05,301.38,211.72Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '326.456px 221.968px' }}
            id="el5chr3q35nwv"
            className="animable"
          />
          <path
            d="M416.53,187.59l9.53-2.37s2.57,2.31,1.24,4.7-3.57,8.42-3.57,8.42l-7.37,2.38-2.08,6-12.68-5.41L405,190.06l7.11-8.8,5.36-.82,3.61,3.06s-3,2.19-5-.17l-2.46.95.22,1.48A2.23,2.23,0,0,0,416.53,187.59Z"
            style={{ fill: 'rgb(255, 190, 157)', transformOrigin: '414.641px 193.58px' }}
            id="el5crhu4y9eyx"
            className="animable"
          />
          <path
            d="M426,185.61l6.23-3a2.54,2.54,0,0,1,2.35.45l.31.65-7.46,4.88Z"
            style={{ fill: 'rgb(255, 190, 157)', transformOrigin: '430.445px 185.543px' }}
            id="eleatl7j64kf7"
            className="animable"
          />
          <path
            d="M412.9,195.32a6.35,6.35,0,0,1,.64-1.58,8.82,8.82,0,0,0,.95-3.85,4.66,4.66,0,0,0-.55-2.06,6,6,0,0,1-.43-.93,2.57,2.57,0,0,1-.12-.91,4.94,4.94,0,0,1,.21-1.72,7.41,7.41,0,0,1,.16,1.7,3.1,3.1,0,0,0,.6,1.63,4.72,4.72,0,0,1,.65,2.27,7.94,7.94,0,0,1-1.14,4A4.86,4.86,0,0,1,412.9,195.32Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '413.955px 189.795px' }}
            id="elapl18c71gv"
            className="animable"
          />
          <path
            d="M441.1,172.58c.09.18,1.38,2.1,1.38,2.1L414.06,195.6l-1.78-2.27Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '427.38px 184.09px' }}
            id="el8vuo5k5zpxk"
            className="animable"
          />
          <path
            d="M423.59,197.92a1.56,1.56,0,0,0-.47-2.2,4.37,4.37,0,0,0-2.45-.56,18.08,18.08,0,0,0-4.16.23,2.71,2.71,0,0,0-1.26.52,1.14,1.14,0,0,0-.4,1.22c.2.53.83.72,1.37.83a19.27,19.27,0,0,0,4.48.35"
            style={{ fill: 'rgb(255, 190, 157)', transformOrigin: '419.332px 196.726px' }}
            id="elht5hlnfvksh"
            className="animable"
          />
          <path
            d="M420.7,198.31a7.45,7.45,0,0,1-2.67.1c-.42,0-.87-.07-1.35-.15a3.88,3.88,0,0,1-1.57-.45,1.22,1.22,0,0,1-.55-.85,1.38,1.38,0,0,1,.29-1,2.71,2.71,0,0,1,1.77-.86,15.89,15.89,0,0,1,3.58-.19,5.57,5.57,0,0,1,2.9.58,1.86,1.86,0,0,1,.87,1.8c-.09.5-.37.65-.38.63s.16-.22.18-.65a1.7,1.7,0,0,0-.86-1.47,5.56,5.56,0,0,0-2.72-.41,18.18,18.18,0,0,0-3.47.22,2.35,2.35,0,0,0-1.46.66.74.74,0,0,0,.12,1.14,3.86,3.86,0,0,0,1.37.43c.47.09.91.16,1.31.21C419.68,198.25,420.7,198.23,420.7,198.31Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '419.268px 196.684px' }}
            id="elqnpr1fxizx"
            className="animable"
          />
          <path
            d="M426,192.1c-2.27-.55-3.89-.78-6.16-1.34a3.58,3.58,0,0,0-2.24-.06c-.71.29-1.15,1.28-.63,1.84a1.79,1.79,0,0,0,.69.41l6.78,2.66"
            style={{ fill: 'rgb(255, 190, 157)', transformOrigin: '421.371px 193.079px' }}
            id="elv1ysl6fbz4"
            className="animable"
          />
          <path
            d="M424.42,195.61a15.37,15.37,0,0,1-2.65-.84L419,193.72l-1.67-.65a1.25,1.25,0,0,1-.77-.81,1.44,1.44,0,0,1,.2-1.13,1.67,1.67,0,0,1,.86-.71,2.66,2.66,0,0,1,1-.13,11.89,11.89,0,0,1,1.78.36l2.93.68a12.89,12.89,0,0,1,2.67.77,18.54,18.54,0,0,1-2.75-.41c-.84-.15-1.85-.32-3-.57a11.06,11.06,0,0,0-1.7-.32,1.45,1.45,0,0,0-1.42.61,1,1,0,0,0-.14.72.78.78,0,0,0,.49.48l1.63.66,2.78,1.15A14.2,14.2,0,0,1,424.42,195.61Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '421.26px 192.947px' }}
            id="elkfv6mgvwe5f"
            className="animable"
          />
          <path
            d="M427.44,188.56l-6.14-1.11a3.6,3.6,0,0,0-2.25.08c-.68.34-1.05,1.35-.5,1.88a1.84,1.84,0,0,0,.71.36L426.2,192"
            style={{ fill: 'rgb(255, 190, 157)', transformOrigin: '422.862px 189.654px' }}
            id="elgtvvhgyqvap"
            className="animable"
          />
          <path
            d="M426.2,192a14.59,14.59,0,0,1-2.69-.66l-2.87-.86-1.7-.53a1.29,1.29,0,0,1-.84-.74,1.45,1.45,0,0,1,.1-1.14,1.64,1.64,0,0,1,.8-.78,2.29,2.29,0,0,1,1-.21,8.81,8.81,0,0,1,1.8.24l2.94.59a15.08,15.08,0,0,1,2.69.67,14.4,14.4,0,0,1-2.75-.31l-3-.48a9,9,0,0,0-1.71-.2,1.4,1.4,0,0,0-1.35.71c-.67,1.22,1.17,1.31,2.12,1.72l2.84,1A15.32,15.32,0,0,1,426.2,192Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '422.729px 189.54px' }}
            id="eldj4c6bmw4pk"
            className="animable"
          />
          <path
            d="M415,205.85,396.5,245.37a12.1,12.1,0,0,1-9.42,6.88h0a12.1,12.1,0,0,1-12.62-7.16l-13.8-31.6,7.84-34.1L387,219.16l15.16-21.48Z"
            style={{ fill: 'rgb(144, 3, 3)', transformOrigin: '387.83px 215.869px' }}
            id="eldg4hq9mwymp"
            className="animable"
          />
          <path
            d="M381.6,232.5a49.71,49.71,0,0,1,2.39-7,52.8,52.8,0,0,1,2.87-6.77,50.2,50.2,0,0,1-2.39,7A52.8,52.8,0,0,1,381.6,232.5Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '384.23px 225.615px' }}
            id="el5dttjlroz3m"
            className="animable"
          />
          <path
            d="M377.5,266.39a6.43,6.43,0,0,1-.11-.84c-.05-.6-.13-1.42-.22-2.44-.19-2.18-.45-5.24-.77-9-.66-7.64-1.57-18.11-2.57-29.67s-2.09-22.07-2.93-29.65c-.43-3.75-.78-6.8-1-9-.12-1-.22-1.84-.29-2.44a4.59,4.59,0,0,1-.06-.86s.07.29.17.84.22,1.41.38,2.43c.31,2.11.73,5.17,1.19,8.95.93,7.57,2,18.05,3.08,29.64s1.87,22.09,2.42,29.69c.25,3.77.46,6.84.6,9,.06,1,.1,1.85.13,2.46A4.32,4.32,0,0,1,377.5,266.39Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '373.541px 224.44px' }}
            id="el601l9gt7o0b"
            className="animable"
          />
          <path
            d="M335.45,263.4l2.41,5s4.78.57,6.76,1.49,9.09,7.11,9.09,7.11a2.35,2.35,0,0,1-2.72,1.25,36.76,36.76,0,0,1-4.5-3h0a2.4,2.4,0,0,0-1.6,3.69c1.42,2.12,3.05,4.59,3.21,5s3.3,1.72,5.66,2.66a1.59,1.59,0,0,1-.25,3,.73.73,0,0,1-.42,0s1.14,2.4-3,1.71c0,0-2.74,1.87-4.87.72,0,0-3.91.88-5.64.3s-8.9-10.69-8.9-10.69l-6.24-11.3Z"
            style={{ fill: 'rgb(255, 190, 157)', transformOrigin: '339.577px 277.964px' }}
            id="else3ikzp1ozh"
            className="animable"
          />
          <path
            d="M341.93,281.53a7.46,7.46,0,0,0,.82,2A11.33,11.33,0,0,0,346,287.7a10.16,10.16,0,0,0,4.95,1.65,6.91,6.91,0,0,0,2.14,0A9,9,0,0,0,351,289a11.44,11.44,0,0,1-4.67-1.72,12.78,12.78,0,0,1-3.23-3.88A9.51,9.51,0,0,0,341.93,281.53Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '347.51px 285.482px' }}
            id="elh3es30y5jjs"
            className="animable"
          />
          <path
            d="M339.89,283.86a4.2,4.2,0,0,0,.65,1.89,13.78,13.78,0,0,0,1.13,1.85,6.76,6.76,0,0,0,1.92,1.88,11.43,11.43,0,0,0,2.47.92l2,.53a6.94,6.94,0,0,0,1.92.37,6.49,6.49,0,0,0-1.8-.75c-.57-.2-1.25-.43-2-.66a12.4,12.4,0,0,1-2.34-.91,6.6,6.6,0,0,1-1.78-1.71,17.25,17.25,0,0,1-1.2-1.72C340.24,284.53,340,283.84,339.89,283.86Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '344.935px 287.58px' }}
            id="elouov71cqsca"
            className="animable"
          />
          <path
            d="M337.74,286.74c-.18.13,1.09,1.94,2.76,4a2.1,2.1,0,0,0,.89.63,7.28,7.28,0,0,0,.87.33,8.87,8.87,0,0,0,1.52.34c.88.11,1.44,0,1.43-.07s-.53-.12-1.36-.33a11.66,11.66,0,0,1-1.42-.44,6.89,6.89,0,0,1-.81-.33,1.77,1.77,0,0,1-.68-.48c-.84-1.06-1.63-2-2.21-2.63S337.8,286.71,337.74,286.74Z"
            style={{ fill: 'rgb(235, 153, 110)', transformOrigin: '341.467px 289.413px' }}
            id="el1aw73hwi4kj"
            className="animable"
          />
          <path
            d="M367,168.83a31.81,31.81,0,0,1-.74,4.93,32.79,32.79,0,0,1-1,4.9,19.1,19.1,0,0,1,.45-5A19.22,19.22,0,0,1,367,168.83Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '366.122px 173.745px' }}
            id="el689qjf684v5"
            className="animable"
          />
          <path
            d="M359.31,171.86a8,8,0,0,1,.62-2.81,8.15,8.15,0,0,1,1.13-2.65,8.44,8.44,0,0,1-.63,2.81A8,8,0,0,1,359.31,171.86Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '360.185px 169.13px' }}
            id="els1arp4nn5g8"
            className="animable"
          />
          <path
            d="M353.65,169.08a7,7,0,0,1,1-2.49,6.86,6.86,0,0,1,1.45-2.25,6.86,6.86,0,0,1-1,2.49A7.13,7.13,0,0,1,353.65,169.08Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '354.875px 166.71px' }}
            id="elb82u6k6qtdn"
            className="animable"
          />
          <path
            d="M346.22,168.22a13.05,13.05,0,0,1,2-3,12.78,12.78,0,0,1,2.39-2.7,12.45,12.45,0,0,1-2,3A12.78,12.78,0,0,1,346.22,168.22Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '348.415px 165.37px' }}
            id="eliop0b1e96pj"
            className="animable"
          />
          <path
            d="M321.65,229.32a19,19,0,0,1-1.66-1.21,15,15,0,0,0-9.21-2.71,15.16,15.16,0,0,1-2,.11,5.68,5.68,0,0,1,2-.48,13.21,13.21,0,0,1,5,.47,13.05,13.05,0,0,1,4.45,2.32A5.62,5.62,0,0,1,321.65,229.32Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '315.215px 227.144px' }}
            id="elvq1ke2ey56o"
            className="animable"
          />
          <path
            d="M316.28,216.54a6.5,6.5,0,0,1,1.6,1.42,16.66,16.66,0,0,1,4.19,9.34,6.18,6.18,0,0,1,0,2.14,22,22,0,0,0-5.78-12.9Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '319.222px 222.99px' }}
            id="el0frtc2ky0v5o"
            className="animable"
          />
          <path
            d="M339.37,260.89a4.24,4.24,0,0,1-.39-.6l-1.05-1.79-3.81-6.68c-3.21-5.73-7.65-13.65-12.67-22.59l-.09-.17.13-.14,3.88-4.08,20.53-21.49,6.26-6.48,1.72-1.74a6.19,6.19,0,0,1,.63-.58,6.38,6.38,0,0,1-.55.66l-1.65,1.8-6.15,6.59c-5.25,5.56-12.45,13.18-20.41,21.59l-3.89,4.09,0-.3c5,9,9.35,16.92,12.52,22.67,1.54,2.84,2.79,5.13,3.68,6.76l1,1.83A3.62,3.62,0,0,1,339.37,260.89Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '337.935px 227.72px' }}
            id="elmpnhfrocty"
            className="animable"
          />
          <g id="elcb61s6hh1ew">
            <g style={{ opacity: '0.3', transformOrigin: '340.435px 212.14px' }} className="animable">
              <path
                d="M329.79,220.56l7.14,5.12a7.81,7.81,0,0,0,2.59-2.2,74.23,74.23,0,0,0,11.56-24.88Z"
                id="eljexr5jejd7"
                className="animable"
                style={{ transformOrigin: '340.435px 212.14px' }}
              />
            </g>
          </g>
          <path
            d="M340.1,209.32a10,10,0,0,0-1.16-3.8,11,11,0,0,0-2.83-3.21,18.69,18.69,0,0,0-4.65-2.53c-1.76-.71-3.51-1.2-5.07-1.83a9.64,9.64,0,0,1-3.73-2.43,5.42,5.42,0,0,1-1.36-2.68,2.16,2.16,0,0,1,0-1.1s0,.4.19,1.06a5.76,5.76,0,0,0,1.43,2.47,9.67,9.67,0,0,0,3.64,2.24c1.52.59,3.29,1.06,5.08,1.78a18.57,18.57,0,0,1,4.76,2.64,10.73,10.73,0,0,1,2.85,3.42,8,8,0,0,1,.88,2.87A3,3,0,0,1,340.1,209.32Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '330.698px 200.53px' }}
            id="elnai8k9cy5l"
            className="animable"
          />
          <path
            d="M372.8,213.78a10.86,10.86,0,0,1-1.34-.09,24.2,24.2,0,0,0-3.61,0c-1.53.11-3.33.37-5.34.68a45.47,45.47,0,0,1-6.62.64,15.39,15.39,0,0,1-6.55-1.28,10.54,10.54,0,0,1-4.16-3.52,7.41,7.41,0,0,1-1.28-3.45,4.67,4.67,0,0,1,0-1c0-.23,0-.34.06-.34s0,.48.14,1.32a7.67,7.67,0,0,0,1.39,3.26,10.29,10.29,0,0,0,4.06,3.29,15.1,15.1,0,0,0,6.34,1.19,46.88,46.88,0,0,0,6.55-.59c2-.28,3.84-.51,5.39-.57a20,20,0,0,1,3.65.15A4.9,4.9,0,0,1,372.8,213.78Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '358.337px 210.218px' }}
            id="ellfu5re140g"
            className="animable"
          />
          <path
            d="M379.51,204.46a10.79,10.79,0,0,1-7.23,5.36c0-.15,1.9-.82,3.89-2.31S379.38,204.37,379.51,204.46Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '375.895px 207.138px' }}
            id="eleu7dxfoui2m"
            className="animable"
          />
          <path
            d="M382.36,211.2a14.8,14.8,0,0,1-9.37,6.64A44.94,44.94,0,0,0,378,215,43.89,43.89,0,0,0,382.36,211.2Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '377.675px 214.52px' }}
            id="eleqkg2dhjx6"
            className="animable"
          />
          <path
            d="M374.1,225a15.05,15.05,0,0,0-5.81-1.81,41.27,41.27,0,0,0-6.67,0,45.57,45.57,0,0,1-8.24-.06,36.84,36.84,0,0,1-14.19-4.6,34,34,0,0,1-3.78-2.51,9.06,9.06,0,0,1-1.26-1.09,11.1,11.1,0,0,1,1.38.93,44.81,44.81,0,0,0,3.84,2.35,38.5,38.5,0,0,0,14.06,4.41,48.82,48.82,0,0,0,8.17.09,38.8,38.8,0,0,1,6.73.09,13.39,13.39,0,0,1,4.37,1.28,7.34,7.34,0,0,1,1.06.63C374,224.87,374.11,225,374.1,225Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '354.125px 219.965px' }}
            id="elnxapbeduj5l"
            className="animable"
          />
          <path
            d="M336,212.74a3,3,0,0,1-.22.69l-.07.19-.08-.19a7.24,7.24,0,0,0-3.23-3.33,16,16,0,0,0-3.43-1.36c-1.29-.39-2.72-.72-4.16-1.24a19,19,0,0,1-7.92-5.5,16.37,16.37,0,0,1-1.7-2.39,3.52,3.52,0,0,1-.47-1c.08-.06.8,1.31,2.45,3.12A20,20,0,0,0,325,207c1.4.51,2.82.85,4.13,1.26a15.08,15.08,0,0,1,3.49,1.47,6.81,6.81,0,0,1,3.17,3.63h-.15C335.86,212.93,336,212.73,336,212.74Z"
            style={{ fill: 'rgb(245, 245, 245)', transformOrigin: '325.36px 206.114px' }}
            id="elmgdqpgr1ru"
            className="animable"
          />
        </g>
        <g id="freepik--Floor--inject-42" className="animable" style={{ transformOrigin: '247.95px 467.48px' }}>
          <path
            d="M478.06,467.48c0,.14-103,.26-230.1.26s-230.12-.12-230.12-.26,103-.26,230.12-.26S478.06,467.34,478.06,467.48Z"
            style={{ fill: 'rgb(38, 50, 56)', transformOrigin: '247.95px 467.48px' }}
            id="elf2p5co3mqp6"
            className="animable"
          />
        </g>
        <defs>
          <filter id="active" height="200%">
            <feMorphology in="SourceAlpha" result="DILATED" operator="dilate" radius={2} />
            <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
            <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
            <feMerge>
              <feMergeNode in="OUTLINE" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
          <filter id="hover" height="200%">
            <feMorphology in="SourceAlpha" result="DILATED" operator="dilate" radius={2} />
            <feFlood floodColor="#ff0000" floodOpacity="0.5" result="PINK" />
            <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
            <feMerge>
              <feMergeNode in="OUTLINE" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
            <feColorMatrix
              type="matrix"
              values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default HomeBannerImage;
